import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import { getColorFromPercentage } from '../utils/colorUtils';

ChartJS.register(ArcElement, Tooltip, Legend);

const OverallScore = ({ score }) => {
  const maxScore = 5.0;
  const isNA = score === 'N/A' || score === null || score === undefined;
  const numericScore = isNA ? 0 : (typeof score === 'number' ? score : parseFloat(score) || 0);
  const percentage = numericScore ? (numericScore / maxScore) * 100 : 0;
  
  const chartData = {
    datasets: [{
      data: [numericScore, maxScore - numericScore],
      backgroundColor: [isNA ? '#95a5a6' : getColorFromPercentage(percentage), '#e9ecef'],
      borderWidth: 0,
    }]
  };

  const chartOptions = {
    rotation: -90, circumference: 180, cutout: '66%', maintainAspectRatio: false,
    plugins: { legend: { display: false }, tooltip: { enabled: false } }
  };

  return (
    <div className="p-6 mb-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 text-center">Overall Project Score</h2>
      <div className="flex items-center justify-center">
        <div className="relative" style={{ width: '320px', height: '190px' }}>
          <Doughnut data={chartData} options={chartOptions} />
          <div className="absolute inset-0 flex flex-col items-center justify-end pb-4">
            <span className="text-4xl font-bold" style={{ color: isNA ? '#95a5a6' : getColorFromPercentage(percentage) }}>
              {isNA ? 'N/A' : numericScore.toFixed(1)}
            </span>
            <span className="text-sm text-gray-500 dark:text-gray-400 mt-1">out of {maxScore}</span>
            {!isNA && <span className="text-sm font-semibold mt-0.5" style={{ color: getColorFromPercentage(percentage) }}>{percentage.toFixed(1)}%</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverallScore;
